#import "./AssetListFields.graphql"

query SearchAssets(
  $page: Int
  $limit: Int
  $search: String
  $categories: [AssetCategoryEnum!]
  $statuses: [AssetStatusEnum!]
  $productTypes: [AssetProductTypeEnum!]
  $entity: AssetEntityEnum
  $employeeId: ID
  $deviceCheck: AssetDeviceCheckFilterEnum
) {
  searchAssets(
    page: $page
    limit: $limit
    search: $search
    categories: $categories
    statuses: $statuses
    productTypes: $productTypes
    entity: $entity
    employeeId: $employeeId
    deviceCheck: $deviceCheck
  ) {
    collection {
      ...AssetListFields
    }
    metadata {
      totalPages
      totalCount
      currentPage
    }
  }
}
